import type { ReactNode } from 'react';
import { cn } from './cn.js';

export interface ListItemProps {
  leading?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  trailing?: ReactNode;
  onClick?: () => void;
  className?: string;
  as?: 'div' | 'button';
  chevron?: boolean;
}

export function ListItem({
  leading,
  title,
  subtitle,
  trailing,
  onClick,
  className,
  as,
  chevron,
}: ListItemProps) {
  const Comp: 'div' | 'button' = as ?? (onClick ? 'button' : 'div');
  return (
    <Comp
      onClick={onClick}
      className={cn(
        'group flex w-full items-center gap-4 rounded-2xl bg-surface-2 border border-line px-4 py-3.5 text-left transition-all',
        onClick &&
          'active:scale-[0.985] hover:border-gold/20 hover:bg-surface-3 cursor-pointer',
        className,
      )}
    >
      {leading && (
        <div className="shrink-0 flex items-center justify-center">{leading}</div>
      )}
      <div className="flex-1 min-w-0">
        <div className="text-[15px] font-medium text-text truncate">{title}</div>
        {subtitle && (
          <div className="mt-0.5 text-xs text-text-dim truncate">{subtitle}</div>
        )}
      </div>
      {trailing && <div className="shrink-0 flex items-center gap-2">{trailing}</div>}
      {chevron && !trailing && (
        <svg
          className="shrink-0 h-5 w-5 text-text-muted group-hover:text-gold transition"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <path d="m8 5 5 5-5 5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </Comp>
  );
}
